import React from 'react';
import { storiesOf } from '@storybook/react';
import DateFilterModal from './DateFilterModal';
import { action } from '@storybook/addon-actions';

storiesOf('Advanced Search/Result Form/Modals', module)
  .add('DateFilterModal', () => (
    <DateFilterModal
      show
      onClose={() => null}
      onSave={action('submitAdvancedSearch')}
      filter={filter}
    />
  ));

const filter = {};


// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/DateFilterModal.stories.jsx